import styled from "styled-components";
import { colors } from "../../styles/colors";



export const ContainerAboutMe = styled.div`
        display: flex;
        /* flex-direction: column; */
        align-items: center;
        justify-content: center;
        margin: 0 auto;
        color: ${colors.TEXT_WHITE};
        padding: 130px 20%;

        @media (max-width: 768px) {
            padding: 100px 0 0 0;
            display: block;
            margin: 0;
            width: 100%;
        }
    
`

export const ExtraDates = styled.div`
    display: flex;
    justify-content: center;
    align-items: center;
    padding: 0 0 80px 0;
    opacity: 0;
    animation-name: locationFadeIn;
    animation-duration: 2s;
    animation-fill-mode: forwards;
    animation-iteration-count: 1;
    animation-timing-function: ease-out;
    animation-delay: 2s;

    p {
        background: #61bdfb;
        background-clip: text !important;
        -webkit-background-clip: text !important;
        -webkit-text-fill-color: transparent !important;
        font-family: 'Russo One', sans-serif;
        font-size: 18px;
    }

    @media (max-width: 768px){
        padding: 0;
        margin-top: 50px;

    }


    @keyframes locationFadeIn {
        from {
            opacity: 0;
            transform: translateY(100%);
        }

        to {
            opacity: 1;
            transform: translateY(0);
        }
    }
`




export const ContainerText = styled.div`
    padding: 0 30px;
    width: 100%;
    opacity: 0;
    animation-name: infoDesliz;
    animation-duration: 2s;
    animation-iteration-count: 1;
    animation-fill-mode: forwards;
    animation-delay: 1s;


    @media (max-width: 768px) {
        padding: 0px;
        text-align: center;
    }


    @keyframes infoDesliz {
        0% {
            opacity: 0;
            transform: translateX(-100%)
        }

        100% {
            opacity: 100;
            transform: translateX(0);
        }
    }
`

export const Title = styled.h1`
    margin: 20px 0;
    p {
        font-size: 35px;
        margin: 0;
        width: 100%;
        font-family: 'Raleway Dots', cursive;
    }

    p:nth-child(2) {
        font-size: 37px;
        /* background: ${colors.TEXT_GRADIENT_PURPLE}; */
        background: #61bdfb;
        background-clip: text !important;
        -webkit-background-clip: text !important;
        -webkit-text-fill-color: transparent !important;
        font-family: 'Russo One', sans-serif;
        text-transform: uppercase;
        /* width: 13ch;
        white-space: nowrap;
        border-right: 4px solid; */
    }

    
    @media (max-width: 768px) {
        padding: 0;
        text-align: center;
        p{
            font-size: 30px;
        }

        p:nth-child(2) {
            font-size: 2rem;
            }
    }
    
    @media (max-width: 468px){
        p{
            font-size: 25px;
        }
        p:nth-child(2) {
                font-size: 1.7rem;
            }
    }
`

export const DescriptionText = styled.div`
    font-size: 20px;
    font-weight: 300;
    color: ${colors.TEXT_WHITE};
    padding-right: 100px;
    
    @media (max-width: 768px) {
        padding-right: 0;

        p {
            padding: 0 20px;
        }
    }
    `

export const ContainerIcons = styled.div`
    display: flex;
    margin-top: 30px;
    img {
        width: 32px;
        height: 32px;
        margin: 10px;
    }
    @media (max-width: 768px){
            justify-content: center;
            
            img {
                justify-content: center;
            }
        }
`

export const ContainerImage = styled.div`
    text-align: center;
    max-width: 300px;
    max-height: 300px;
    border-radius: 100%;
    overflow: hidden;
    /* border-style: solid; */
    z-index: 90;
    opacity: 0;
    animation-name: imageDesliz;
    animation-duration: 2s;
    animation-fill-mode: forwards;
    animation-iteration-count: 1;
    animation-timing-function: ease-out;
    animation-delay: 1.5s;

    img {
        width: 100%;
        height: 100%;
    }


    @keyframes imageDesliz {
        0% {
            transform: translateX(100%);
            opacity: 0;
        }

        100% {
            transform: translateX(0);
            opacity: 100;
        }
    }
    
    @media (max-width: 768px) {
        width: 100%;
        margin: 0 auto;
        margin-top: 50px;
        
        img {
            width: 100%;
        }

        @media (max-width: 340px){
        max-width: 200px;
        max-height: 200px;
    }
}
`